module.exports = __webpack_public_path__ + "filetype-unknown.svg?1eab0b0ae29c465a8882ff5ec48a96a5";